import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMembershipPlans } from "../store/membership/membershipActions";
import { getEffectivePlan } from "../utils/subscriptionUtils";
import {
  getUserDefaultPaymentMethod,
  getUserSubscription,
} from "../store/auth/authActions";

export const useMembershipsData = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, user, currentSubscription } = useSelector(
    (state) => state.auth,
  );

  const currentPlan = getEffectivePlan(currentSubscription);

  const { plans, isLoading: isMembershipLoading } = useSelector(
    (state) => state.membership,
  );

  // A user is trial-eligible when:
  //   1. They are not authenticated (guest — show trial marketing), OR
  //   2. They are a seller on the free plan AND have never used a trial.
  //      hasUsedTrial covers the downgrade case where isTrial and trialExpired
  //      are both false but the user already consumed their one free trial.
  const trialEligible =
    !isAuthenticated ||
    (user?.role === "seller" &&
      (currentPlan === "free" || !currentPlan) &&
      !user?.membership?.isTrial &&
      !user?.membership?.trialExpired &&
      !user?.hasUsedTrial);

  useEffect(() => {
    dispatch(fetchMembershipPlans());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated && user?.uid) {
      dispatch(getUserSubscription(user?.uid));
    }
  }, [dispatch, isAuthenticated, user]);

  useEffect(() => {
    if (isAuthenticated && user?.uid && currentPlan !== "free") {
      dispatch(getUserDefaultPaymentMethod(user?.uid));
    }
  }, [dispatch, isAuthenticated, user]);

  return { plans, isMembershipLoading, trialEligible };
};
